export enum OfferPremiumInstallmentCode {
    ONE_INSTALMENT = 'ONE_INSTALMENT',
    TWO_INSTALMENT = 'TWO_INSTALMENT',
    FOUR_INSTALMENT = 'FOUR_INSTALMENT',
    TWELVE_INSTALMENT = 'TWELVE_INSTALMENT',
}
